export type Testimonial = {
  name: string
  trip: string
  quote: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Valeria y Martín',
    trip: 'Budapest · Viena · Praga',
    quote:
      'Hicimos Budapest, Viena y Praga y salió todo muchísimo mejor de lo que esperábamos. Al principio queríamos meter más ciudades, pero por suerte armamos una ruta más lógica y terminamos disfrutando mucho más cada lugar.',
    photo: 'https://cdn.magicpatterns.com/uploads/6bfHKgcFTRmtXShL5bTwDj/pareja_joven_europ.jpg',
  },
  {
    name: 'Dani y Julia',
    trip: 'Viaje con presupuesto ajustado',
    quote:
      'Nos sirvieron un montón las plantillas de gastos porque viajábamos con presupuesto bastante ajustado y necesitábamos tener claro cuánto podíamos movernos sin pasarnos. Nos ayudó a ordenar todo mucho más de lo que pensábamos.',
    photo:
      'https://cdn.magicpatterns.com/uploads/geNntdXHtfRLHz7z4yuBqn/pareja_mujeres_mochileras.jpg',
  },
  {
    name: 'Patricia y Andrés',
    trip: 'Bélgica y Países Bajos',
    quote:
      'Menos mal que revisamos todo con tiempo porque nos dimos cuenta de que no teníamos la documentación tan en orden como creíamos. El checklist nos hizo frenar, revisar bien y viajar mucho más tranquilos.',
    photo: 'https://cdn.magicpatterns.com/uploads/4Uyur6vHV6sD4yJLVGveoV/pareja_mayor_europa.jpg',
  },
  {
    name: 'Mariana y Paula',
    trip: 'Roma',
    quote:
      'Pudimos entrar al Coliseo sin problema porque sacamos las entradas con bastante anticipación. Si no lo hacíamos así, probablemente nos quedábamos afuera o pagábamos mucho más. Ese tipo de detalles hacen toda la diferencia.',
    photo: 'https://cdn.magicpatterns.com/uploads/kKcZ7jG21HuPsDTDz3r2uN/mujeres_roma.jpg',
  },
  {
    name: 'Lucía',
    trip: 'Primer viaje sola · París',
    quote:
      'Era la primera vez que hacía un viaje así sola y me ayudó mucho tener una base clara para organizarme. Sobre todo con los gastos y con las reservas, porque me dio mucha más tranquilidad salir ya con varias cosas definidas.',
    photo: 'https://cdn.magicpatterns.com/uploads/bZDQWDTtshYHaJp6XzJKEF/mujer_sola_paris.jpg',
  },
  {
    name: 'Fernanda y Diego',
    trip: 'Norte de Europa',
    quote:
      'Nos vino bárbaro para bajar a tierra el itinerario. Habíamos armado algo mucho más cargado y al final dejamos menos paradas, con más tiempo en cada lugar. Se sintió mucho más disfrutable y mucho menos corrido.',
    photo: 'https://cdn.magicpatterns.com/uploads/sr7RvxuSN3kn19BeHzBT5U/testimonio_pareja.jpg',
  },
  {
    name: 'Camila y Mateo',
    trip: 'Budapest',
    quote:
      'Teníamos mil ideas guardadas y cero orden. Lo que más nos sirvió fue poder acomodar mejor la ruta y tener una idea bastante real de los gastos antes de empezar a reservar cualquier cosa.',
    photo:
      'https://cdn.magicpatterns.com/uploads/amru5Mic8YZAav7U6FHJk3/testimonio_pareja_joven.jpg',
  },
]
